module.exports = __webpack_public_path__ + "1793882494189/images/32px.e1d0c01.png";